const isDigit = (value) => {
  if (!Number.isSafeInteger(value)) return false;
  return value >= 0 && value <= 9;
};

// noinspection JSUnusedGlobalSymbols
export default isDigit;
